import { MainContainer } from "./main-container";
export * from "./main-container";
export var LAYOUT_DIRECTIVES = [
    MainContainer
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/layout/main-container/index.js
// module id = 187
// module chunks = 4